import { Component, OnInit } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
@Component({
  selector: 'app-our-terms',
  templateUrl: './our-terms.component.html',
  styleUrls: ['./our-terms.component.scss']
})

export class OurTermsComponent implements OnInit {
  assessmentInfo: any = {
    candidateName: '',
    email: '',
    name: '',
    duration: null,
    welcomeTemplate: ''
  };
  assessmentId: any;
  constructor(private storage: StorageMap){
    this.assessmentInfo = [];
  }
  ngOnInit(): void {
    this.storage.get('welcomeViewData').subscribe((assessmentInfo: any) => {
      if (assessmentInfo) {
        this.assessmentInfo = {
          candidateName: assessmentInfo?.candidateName,
          email: assessmentInfo?.email,
          name: assessmentInfo?.assessments[0]?.name,
          duration: assessmentInfo?.assessments[0]?.duration,
          welcomeTemplate: assessmentInfo?.assessments[0]?.welcomeTemplate
        };
        this.assessmentId = assessmentInfo?.assessments[0]?.assessmentId;
      }
    })
  }

}
